import React, { useState } from 'react';
import { format, parseISO, addMonths, startOfMonth, endOfMonth } from 'date-fns';
import { useShift, Shift } from '../context/ShiftContext';
import { useUser } from '../context/UserContext';
import { RepeatIcon, CheckIcon } from 'lucide-react';
const TradeShifts = () => {
  const {
    shifts,
    trades,
    addTrade,
    acceptTrade
  } = useShift();
  const {
    user,
    users
  } = useUser();
  const [successMessage, setSuccessMessage] = useState('');
  // Filter shifts assigned to current user
  const userShifts = user ? shifts.filter(s => s.assignedTo.includes(user.id) && new Date(s.date) >= new Date() && !s.isAvailableForTrade) : [];
  // Filter shifts available for trade (not including user's own shifts)
  const availableTradeShifts = user ? shifts.filter(s => s.isAvailableForTrade && !s.assignedTo.includes(user.id) && new Date(s.date) >= new Date()) : [];
  const handleOfferShift = (shiftId: number) => {
    if (!user) return;
    addTrade(shiftId, user.id);
    setSuccessMessage('Your shift has been offered for trade!');
    setTimeout(() => {
      setSuccessMessage('');
    }, 5000);
  };
  const handleAcceptTrade = (shiftId: number) => {
    if (!user) return;
    const trade = trades.find(t => t.shiftId === shiftId);
    if (trade) {
      acceptTrade(trade.id, user.id);
      setSuccessMessage('You have successfully accepted the trade!');
      setTimeout(() => {
        setSuccessMessage('');
      }, 5000);
    }
  };
  const getShiftTypeLabel = (shift: Shift) => {
    switch (shift.type) {
      case 'night':
        return 'Night Shift';
      case 'weekend':
        return 'Weekend Shift';
      case 'holiday':
        return 'Holiday Shift';
    }
  };
  return <div className="space-y-6" data-id="element-430">
      <div className="bg-white rounded-lg shadow-md p-6" data-id="element-431">
        <h2 className="text-2xl font-bold mb-4 text-gray-800" data-id="element-432">Trade Shifts</h2>
        <p className="text-gray-600 mb-4" data-id="element-433">
          Offer your shifts for trade or accept shifts offered by other APNs.
        </p>
        {successMessage && <div className="border px-4 py-3 rounded mb-4" style={{
        backgroundColor: '#D1FAE5',
        borderColor: '#10B981',
        color: '#065F46'
      }} data-id="element-434">
            {successMessage}
          </div>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-435">
          <div data-id="element-436">
            <h3 className="text-xl font-semibold mb-4 text-gray-700" data-id="element-437">
              Your Shifts
            </h3>
            {userShifts.length > 0 ? <ul className="divide-y divide-gray-200" data-id="element-438">
                {userShifts.map(shift => <li key={shift.id} className="py-4" data-id="element-439">
                    <div className="flex justify-between items-center" data-id="element-440">
                      <div data-id="element-441">
                        <p className="font-medium text-gray-900" data-id="element-442">
                          {format(parseISO(shift.date), 'MMMM d, yyyy')} (
                          {format(parseISO(shift.date), 'EEEE')})
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-443">
                          {getShiftTypeLabel(shift)}
                        </p>
                      </div>
                      <button onClick={() => handleOfferShift(shift.id)} className="flex items-center px-3 py-1 rounded text-white" style={{
                  backgroundColor: '#4772B0'
                }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3A5D8F'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#4772B0'} data-id="element-444">
                        <RepeatIcon size={16} className="mr-1" data-id="element-445" /> Offer
                      </button>
                    </div>
                  </li>)}
              </ul> : <p className="text-gray-500" data-id="element-446">
                You don't have any upcoming shifts to trade.
              </p>}
          </div>
          <div data-id="element-447">
            <h3 className="text-xl font-semibold mb-4 text-gray-700" data-id="element-448">
              Available Trades
            </h3>
            {availableTradeShifts.length > 0 ? <ul className="divide-y divide-gray-200" data-id="element-449">
                {availableTradeShifts.map(shift => {
              const offeredByUsers = shift.assignedTo.map(userId => users.find(u => u.id === userId)).filter(Boolean);
              return <li key={shift.id} className="py-4" data-id="element-450">
                      <div className="flex justify-between items-center" data-id="element-451">
                        <div data-id="element-452">
                          <p className="font-medium text-gray-900" data-id="element-453">
                            {format(parseISO(shift.date), 'MMMM d, yyyy')} (
                            {format(parseISO(shift.date), 'EEEE')})
                          </p>
                          <p className="text-sm text-gray-500" data-id="element-454">
                            {getShiftTypeLabel(shift)} • Offered by{' '}
                            {offeredByUsers.map(u => u?.name).join(', ') || 'Unknown'}
                          </p>
                        </div>
                        <button onClick={() => handleAcceptTrade(shift.id)} className="flex items-center px-3 py-1 rounded text-white" style={{
                    backgroundColor: '#10B981'
                  }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#059669'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#10B981'} data-id="element-455">
                          <CheckIcon size={16} className="mr-1" data-id="element-456" /> Accept
                        </button>
                      </div>
                    </li>;
            })}
              </ul> : <p className="text-gray-500" data-id="element-457">
                There are no shifts available for trade right now.
              </p>}
          </div>
        </div>
      </div>
    </div>;
};
export default TradeShifts;